import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Layout from "./layout";

function getAuth() {
  const email = localStorage.getItem("email");
  const role = localStorage.getItem("role");
  // Admin: has email set via Google Sign-In (role may be null for existing users)
  // Waiter: has role="waiter" set by PIN login
  const isAdmin = email && email.length > 0 && role !== "waiter";
  const isWaiter = role === "waiter";
  const onboardingComplete = localStorage.getItem("onboardingComplete") !== "false";
  return { isAuthenticated: isAdmin || isWaiter, isAdmin, isWaiter, onboardingComplete };
}

function Private({ Component }) {
  const { isAuthenticated, isAdmin, isWaiter, onboardingComplete } = getAuth();
  if (!isAuthenticated) return <Navigate to="/" />;
  if (isAdmin && !onboardingComplete) return <Navigate to="/onboarding" />;
  return (
    <Layout isAdmin={isAdmin} isWaiter={isWaiter}>
      <Component />
    </Layout>
  );
}

// Wraps onboarding: authenticated admin only, NO Layout/nav
function OnboardingOnly({ Component }) {
  const { isAuthenticated, isAdmin } = getAuth();
  if (!isAuthenticated) return <Navigate to="/" />;
  if (!isAdmin) return <Navigate to="/dashboard" />;
  return <Component />;
}

// Wraps routes that only admins can access
function AdminOnly({ Component }) {
  const { isAuthenticated, isAdmin, onboardingComplete } = getAuth();
  if (!isAuthenticated) return <Navigate to="/" />;
  if (!isAdmin) return <Navigate to="/dashboard" />;
  if (!onboardingComplete) return <Navigate to="/onboarding" />;
  return (
    <Layout isAdmin={true} isWaiter={false}>
      <Component />
    </Layout>
  );
}

const AuthWrapper = ({ Component }) => {
  const location = useLocation();
  const { isAuthenticated, isAdmin, onboardingComplete } = getAuth();
  if (isAuthenticated && location.pathname === "/") {
    if (isAdmin && !onboardingComplete) return <Navigate to="/onboarding" />;
    return <Navigate to="/dashboard" />;
  }
  return <Component />;
};

export { Private, AdminOnly, OnboardingOnly, AuthWrapper };
